
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "L’intérêt pour une entreprise de bien choisir son logo",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Posséder un logo est indispensable pour toute entreprise souhaitant se faire connaître au plus grand nombre et fidéliser sa clientèle sur le très long terme.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "L’intérêt pour une entreprise de bien choisir son logo",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Posséder un logo est indispensable pour toute entreprise souhaitant se faire connaître au plus grand nombre et fidéliser sa clientèle sur le très long terme.",
        },
      ],
    };
  },
};
